
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exam/detail/[examIdx]",
      function () {
        return require("private-next-pages/exam/detail/[examIdx]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exam/detail/[examIdx]"])
      });
    }
  